export enum CompanyStatus {
  pending = 'Pending',
  active = 'Active',
  terminated = 'Terminated',
}
